import style from "./MaintenanceInspectionRecord.module.css";
import logo from "../../../assets/images/logo-hacom-2024.png";
import logoDVT from "../../../assets/images/logoDVT.svg";

// Ô điền: có dữ liệu thì bỏ gạch chân, còn trống thì giữ gạch chấm để viết tay
const Fill = ({ value }: { value?: any }) => (
  <span
    className={
      value && String(value).trim()
        ? `${style.fill} ${style.filled}`
        : style.fill
    }
  >
    {value}
  </span>
);

// Biên bản kiểm tra bảo trì sản phẩm theo mẫu BM.HCKT.HACOM_0117,
// các sản phẩm của phiếu liệt kê ở bảng mục II
const MaintenanceInspectionRecord = ({
  innerRef,
  dataPrint,
}: {
  innerRef: any;
  dataPrint: any;
}) => {
  const isDVT = dataPrint?.companyCode === "DVT";
  const createDate = dataPrint?.createDate
    ? new Date(dataPrint.createDate)
    : null;
  const pad = (value: number) => String(value).padStart(2, "0");
  const address = [dataPrint?.additionalAddress, dataPrint?.meetingAddress]
    .filter((i) => i && String(i).length > 0)
    .join(" - ");
  const items: any[] =
    dataPrint?.tblWarrantyServiceRequestFormDetailModels ?? [];

  return (
    <div ref={innerRef} className={style.page}>
      <div className={style.header}>
        <img
          src={isDVT ? logoDVT : logo}
          alt={isDVT ? "logoDVT" : "logo Hacom"}
          width={isDVT ? 175 : 150}
          height={isDVT ? 50 : 64}
          // logo HACOM là ảnh vuông nhiều khoảng trống trên dưới, cắt bớt cho header gọn
          style={{ objectFit: isDVT ? "contain" : "cover" }}
        />
        <div>
          <p className={style.companyName}>
            {isDVT
              ? "CÔNG TY CỔ PHẦN HACOM DỊCH VỤ TỐT"
              : "CÔNG TY CỔ PHẦN ĐẦU TƯ CÔNG NGHỆ HACOM"}
          </p>
          <div className={style.headerLine}>
            <p className={style.red}>Trụ sở:</p>
            <p>129+131 Lê Thanh Nghị, P.Bạch Mai, TP.Hà Nội</p>
          </div>
          <div className={style.headerLine}>
            <p className={style.red}>VPGD:</p>
            <p>
              Tầng 3 Tòa nhà LILAMA, số 124 Minh Khai, P.Tương Mai,
              TP.Hà Nội
            </p>
          </div>
          <div className={style.headerContact}>
            <div className={style.headerLine}>
              <p className={style.red}>Tel:</p>
              <p>{isDVT ? "1800 8091" : "1900 1903"}</p>
            </div>
            <div className={style.headerLine}>
              <p className={style.red}>Email:</p>
              <p>info@hacom.vn</p>
            </div>
            <div className={style.headerLine}>
              <p className={style.red}>Website:</p>
              <p>{isDVT ? "dichvutot.vn" : "hacom.vn"}</p>
            </div>
          </div>
        </div>
      </div>

      <h2 className={style.title}>BIÊN BẢN KIỂM TRA BẢO TRÌ SẢN PHẨM</h2>
      <p className={style.place}>
        {dataPrint?.nameBranch || "HACOM"}, Ngày{" "}
        {createDate ? pad(createDate.getDate()) : "……"} tháng{" "}
        {createDate ? pad(createDate.getMonth() + 1) : "……"} năm{" "}
        {createDate ? createDate.getFullYear() : "20……"}
      </p>
      <div className={style.row}>
        <div className={style.half}>
          <span className={style.label}>Họ và tên khách hàng:</span>
          <Fill value={dataPrint?.custMeeting} />
        </div>
        <div className={style.half}>
          <span className={style.labelItalic}>Điện thoại liên hệ:</span>
          <Fill value={dataPrint?.custPhone} />
        </div>
      </div>
      <div className={style.row}>
        <div className={style.half}>
          <span className={style.label}>Địa chỉ:</span>
          <Fill value={address} />
        </div>
        <div className={style.auto}>
          <span className={style.labelItalic}>
            Thời gian tiếp nhận lúc:{" "}
            {createDate ? pad(createDate.getHours()) : "……"} giờ{" "}
            {createDate ? pad(createDate.getMinutes()) : "……"} phút.
          </span>
        </div>
      </div>

      <div className={`${style.row} ${style.sectionRow}`}>
        <b>I. Yêu cầu tiếp nhận:</b>
        <span>Bảo trì</span>
      </div>

      <p className={style.section}>II. Thông tin sản phẩm:</p>
      <table className={style.productTable}>
        <thead>
          <tr>
            <th>Mã sản phẩm</th>
            <th>Tên sản phẩm</th>
            <th>Serial</th>
            <th>Phụ kiện đi kèm</th>
          </tr>
        </thead>
        <tbody>
          {(items.length > 0 ? items : [null]).map(
            (item: any, index: number) => (
              <tr key={index}>
                <td>{item?.itemCode}</td>
                <td>{item?.itemName}</td>
                <td>{item?.serial}</td>
                <td></td>
              </tr>
            ),
          )}
        </tbody>
      </table>

      <div className={`${style.row} ${style.sectionRow}`}>
        <b>III. Tình trạng sản phẩm nhận ban đầu:</b>
        <Fill value={dataPrint?.content} />
      </div>

      <p className={style.riskNote}>
        - Trường hợp phát sinh rủi ro lỗi, hỏng từ thao tác vệ sinh máy,
        Kỹ Thuật viên sẽ nhận lại thiết bị của khách hàng để kiểm tra sửa
        chữa. <b>HACOM</b> sẽ chịu chi phí sửa chữa với các lỗi về phần
        cứng phát sinh từ nguyên nhân này.
      </p>

      <div className={style.signature}>
        <div>
          <p>
            <b>Nhân viên Kỹ Thuật</b>
          </p>
          <p>
            <i>(Ký và ghi rõ họ tên)</i>
          </p>
        </div>
        <div>
          <p>
            <b>Đại diện Khách Hàng</b>
          </p>
          <p>
            <i>(Ký và ghi rõ họ tên)</i>
          </p>
        </div>
      </div>
      <p className={style.formCode}>BM.HCKT.HACOM_0117</p>
    </div>
  );
};

export default MaintenanceInspectionRecord;
